import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Navbar from './components/Navbar';
import { getWebClient, getDataTablesLanguage } from '../helpers/Helpers.js';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';

export default function AziendeSeller() {

    DataTable.use(DT);

    const navigate = useNavigate();

    const columns = [
        { data: 'ragioneSociale' },
        { data: 'localita' },
        { data: 'nazione' },
        { data: 'dataOraUltimoAggiornamento' },
        { data: 'abilitato' },
        {
            width: '87px',
            data: 'id',
            orderable: false
        }
    ];

    const options = {
        language: getDataTablesLanguage(),
        paging: false,
        createdRow: (row, data, dataIndex) => {
            if (data.abilitato !== 'Abilitato') {
                row.classList.add('text-danger');              
            }
        }
    };

    const [tableData, setTableData] = useState([]);

    function transformData(data) {

        let result = [];

        data.forEach(function (item, index) {
            result.push(
                {
                    id: item.id,
                    ragioneSociale: item.ragioneSociale,
                    localita: item.localita,
                    nazione: item.nazione,
                    dataOraUltimoAggiornamento: item.dataOraUltimoAggiornamento,
                    abilitato: item.abilitato ? 'Abilitato' : 'Non abilitato'
                }
            );
        });

        return result;

    }

    function handleDetailsClick(data) {
        navigate(`/aziendeseller/${data}`);
    }

    useEffect(() => {

        const client = getWebClient();

        client.get(`/api/aziendeseller`)
            .then(function (response) {
                setTableData(transformData(response.data));
            })
            .catch(function (error) {
                console.log(error);
            });

    }, []);

    return (
        <>

            <link href="https://cdn.datatables.net/v/bs5/dt-2.1.8/datatables.min.css" rel="stylesheet"></link>

            <style
                dangerouslySetInnerHTML={{
                    __html: "tr.text-danger td {color: inherit;} tr.text-danger td div a {color: inherit;}"
                }}
            />

            <Navbar />

            <div className="container" style={{ marginTop: 40, marginBottom: 40 }} >
                <div className="row">
                    <div className="col">
                        <h4>Aziende seller</h4>
                    </div>
                    <div className="col text-end">
                        <a href="/aziendeseller/new" style={{ position: 'relative', top: 7 }} onClick={(ev) => { ev.preventDefault(); navigate("/aziendeseller/new") }}>Crea nuovo seller</a>
                    </div>
                </div>
            </div>

            <div className="container">
                <DataTable data={tableData} columns={columns} options={options} className="table"
                slots={{
                    5: (data, row) => (
                        <a href={`aziendeseller/${data}`} onClick={(ev) => { ev.preventDefault(); handleDetailsClick(data) }}>Dettagli</a>
                    )
                }}
                >
                    <thead>
                        <tr>
                            <th>Ragione sociale</th>
                            <th>Localita</th>
                            <th>Nazione</th>
                            <th>Ultimo aggiornamento</th>
                            <th>Stato</th>
                        </tr>
                    </thead>
                </DataTable>
                <br></br>
                <br></br>
            </div>

        </>
    )
}
